module.exports = "pegasus/assets/coupon-preview.png";